/** Author-side membership DML; never installed as database triggers. */
export const pageRelationBodies = {
  update: String.raw`
    DELETE FROM pageRelations WHERE fromPageId=NEW.id AND type='link'
      AND node IN (SELECT node FROM crdt_applied(NEW.data))
      AND (NEW.deletedAt IS NOT NULL OR NOT EXISTS (
        SELECT 1 FROM crdt_attr_lookup('idx_pages_crdt_attr',pageRelations.toPageId,NEW.rowid) parts
        WHERE parts.node=pageRelations.node AND json_extract(parts.fields,'$.type')='pageLink'
          AND json_extract(parts.fields,'$.pageId')=pageRelations.toPageId));
    INSERT INTO pageRelations(fromPageId,toPageId,node,targetSpaces,type)
      SELECT NEW.id,json_extract(parts.fields,'$.pageId'),parts.node,
        ':'||hex(COALESCE(json_extract(parts.fields,'$.spaceId'),''))||':','link'
      FROM crdt_attr_lookup('idx_pages_crdt_attr',NULL,NEW.rowid) parts
      WHERE NEW.deletedAt IS NULL AND json_extract(parts.fields,'$.type')='pageLink'
        AND json_type(parts.fields,'$.pageId')='text'
        AND parts.node IN (SELECT node FROM crdt_applied(NEW.data))
      ON CONFLICT(fromPageId,toPageId,type,node) DO UPDATE SET targetSpaces=excluded.targetSpaces
      WHERE pageRelations.targetSpaces IS NOT excluded.targetSpaces;
  `,
  lifecycle: String.raw`
    DELETE FROM pageRelations WHERE fromPageId=NEW.id AND type='link' AND NEW.deletedAt IS NOT NULL;
    INSERT INTO pageRelations(fromPageId,toPageId,node,targetSpaces,type)
      SELECT NEW.id,json_extract(parts.fields,'$.pageId'),parts.node,
        ':'||hex(COALESCE(json_extract(parts.fields,'$.spaceId'),''))||':','link'
      FROM crdt_attr_lookup('idx_pages_crdt_attr',NULL,NEW.rowid) parts
      WHERE NEW.deletedAt IS NULL AND json_extract(parts.fields,'$.type')='pageLink'
        AND json_type(parts.fields,'$.pageId')='text'
      ON CONFLICT(fromPageId,toPageId,type,node) DO UPDATE SET targetSpaces=excluded.targetSpaces
      WHERE pageRelations.targetSpaces IS NOT excluded.targetSpaces;
  `,
}
